var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-flex',{staticClass:"poster-search-mode-selector poster-search-mode-selector__root"},[_c('ul',_vm._l((_vm.items),function(searchMode){return _c('li',{key:searchMode.itemId,staticClass:"poster-search-mode-selector__mode-element",class:{
        selected: _vm.value && _vm.value.itemId === searchMode.itemId,
      },on:{"click":function($event){return _vm.$emit('change', searchMode)}}},[_c('i',{staticClass:"picto mdi mdi-magnify"}),_c('span',[_vm._v(_vm._s(_vm.piivoTranslate(searchMode)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }